export default __webpack_public_path__ + "static/media/sj.5cc5ebd4.png";